<script lang="ts">
import { defineComponent, PropType } from 'vue'
import StepLayout from './StepLayout.vue'
import ButtonSubmit from '@/components/button/ButtonSubmit.vue'
import NewsletterSetupForRegistration from '@/components/user/registration/NewsletterSetupForRegistration.vue'
import ValidationObserver from '@/components/validation/ValidationObserver.vue'
import validationOperator from '@/models/validationOperator'

export default defineComponent({
  name: 'NewsLetterStep',

  components: {
    StepLayout,
    ValidationObserver,
    ButtonSubmit,
    NewsletterSetupForRegistration,
  },

  props: {
    namespace: {
      type: String,
      required: true,
    },

    inputOptionalNewsletterInfo: {
      type: Object as PropType<OptionalNewsletterSettings>,
      required: true,
    },
  },

  emits: [
    'update:mailStopFlag',
    'update:mailNewsStopFlag',
    'update:mailExpoStopFlag',
    'update:mailAiStopFlag',
    'click:next',
    'click:prev',
  ],

  setup(props, { emit }) {
    const { validationObserver, validate } = validationOperator()

    const next = () => {
      emit('click:next')
    }

    return {
      // data
      validationObserver,

      // computed

      // methods
      validate,
      next,
    }
  },
})
</script>

<template>
  <StepLayout
    :required="false"
    @click:prev="$emit('click:prev')">
    <template #title>
      ニュースレターの選択
    </template>
    <template #caption>
      複数選択してください
    </template>
    <template #description>
      <ValidationObserver
        ref="validationObserver"
        :namespace="namespace"
        @valid="next">
        <NewsletterSetupForRegistration
          :namespace="namespace"
          :input-optional-newsletter-info="inputOptionalNewsletterInfo"
          @update:mail-stop-flag="$emit('update:mailStopFlag', $event)"
          @update:mail-news-stop-flag="$emit('update:mailNewsStopFlag', $event)"
          @update:mail-expo-stop-flag="$emit('update:mailExpoStopFlag', $event)"
          @update:mail-ai-stop-flag="$emit('update:mailAiStopFlag', $event)" />

        <ButtonSubmit
          :is-link="false"
          :has-shadow="false"
          :width="384"
          prevent
          stop
          @click:submit="validate">
          次へ
        </ButtonSubmit>
      </ValidationObserver>
    </template>
  </StepLayout>
</template>
